import { Component, Input, OnInit } from '@angular/core';
import { LeadCategoria, LeadInsucesso } from '../interfaces/lead-summary';

@Component({
  selector: 'app-resumo-leads-grid',
  templateUrl: './resumo-leads-grid.component.html',
  styleUrls: ['./resumo-leads-grid.component.css']
})
export class ResumoLeadsGridComponent implements OnInit {
  @Input() leadCategoria!: LeadCategoria;

  constructor() { }

  ngOnInit() {
  }

  public destacaCategoria(descricao: string): string {
    if(descricao === 'Insucesso (só nos qualificados)'){
      return 'texto-vermelho';
    }
  }

}
